module.exports = "<section class=\"container titolo notab\">\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<h1>\n\t\t\t\t<span class=\"fa fa-exclamation-circle\"></span>\n\t\t\t\tLa pagina che hai cercato è inesistente\n\t\t\t</h1>\n\t\t</div>\n\t</div>\n</section>\n\n<section>\n\t<div class=\"container\">\n\t</div>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.html
// module id = ./src/app/components/not-found/not-found.component.html
// module chunks = main